import * as DAOUtils from "../utils/DAOUtils";

export function getMedKeyTypes(locationId) {
  return DAOUtils.get(`/locations/${locationId}/medKeyTypes`);
}

export async function getMedKeyTypeName(locationId, medKeyType) {
  const availableMedKeyTypes = await getMedKeyTypes(locationId);
  return availableMedKeyTypes.find(m => m.key === medKeyType).name;
}
